import React from 'react';
import * as I18n from 'circe/I18n';
// account-child-circle
// account-group-outline
import AccountHeartIcon from 'mdi-react/AccountHeartIcon';
import AccountOffIcon from 'mdi-react/AccountOffIcon';
import AccountKeyIcon from 'mdi-react/AccountKeyIcon';
import { NAME as AUTH_NAME, AUTHORITIES, ROLES } from '../constants';

export const NAME = `${AUTH_NAME}/PROFILES`;
export const SELECTED_PROFILE_LOCAL_KEY = 'selectedProfile';
export const REFRESH_TOKENS_TIMEOUT = 7 * 24 * 60 * 60 * 1000;
export const PROFILE_STATUS = {
  EMPTY: 'EMPTY',
  ACTIVE: 'ACTIVE',
  IN_ACTIVE: 'IN_ACTIVE',
  PENDING_USER_ACTION: 'PENDING_USER_ACTION',
  SUSPENEDED: 'SUSPENEDED',
  PENDING: 'PENDING',
};

export const PROFILES_CONFIG = {
  [AUTHORITIES.ACCOUNT_ADMIN]: {
    title: ROLES.ACCOUNT_ADMIN,
    grant: {
      title: I18n.str('grantAccountAdmin', 'Grant Account Admin'),
      message: '',
      icon: <AccountKeyIcon />,
      statuses: [PROFILE_STATUS.EMPTY],
      authorities: [AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DOMAIN_ADMIN],
    },
    approve: {
      title: I18n.str('approveAccountAdmin', 'Approve Account Admin'),
      message: '',
      icon: <AccountHeartIcon />,
      statuses: [PROFILE_STATUS.SUSPENEDED, PROFILE_STATUS.PENDING],
      authorities: [AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DOMAIN_ADMIN],
    },
    revoke: {
      title: I18n.str('revokeAccountAdmin', 'Revoke Account Admin'),
      message: '',
      icon: <AccountOffIcon />,
      statuses: [PROFILE_STATUS.ACTIVE, PROFILE_STATUS.PENDING],
      authorities: [AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DOMAIN_ADMIN],
    },
  },
  [AUTHORITIES.FINANCE_ADMIN]: {
    title: ROLES.FINANCE_ADMIN,
    grant: {
      title: I18n.str('grantFinanceAdmin', 'Grant Finance Admin'),
      message: '',
      icon: <AccountKeyIcon />,
      statuses: [PROFILE_STATUS.EMPTY, PROFILE_STATUS.SUSPENEDED],
      authorities: [AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DOMAIN_ADMIN],
    },
    approve: {
      title: I18n.str('approveFinanceAdmin', 'Approve Finance Admin'),
      message: '',
      icon: <AccountHeartIcon />,
      statuses: [PROFILE_STATUS.SUSPENEDED, PROFILE_STATUS.PENDING],

      authorities: [AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DOMAIN_ADMIN],
    },
    revoke: {
      title: I18n.str('revokeFinanceAdmin', 'Revoke Finance Admin'),
      message: '',
      icon: <AccountOffIcon />,
      statuses: [PROFILE_STATUS.ACTIVE, PROFILE_STATUS.PENDING],
      authorities: [AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DOMAIN_ADMIN],
    },
  },
  [AUTHORITIES.OPERATOR]: {
    title: ROLES.OPERATOR,
    grant: {
      title: I18n.str('grantOperator', 'Grant Operator'),
      message: '',
      statuses: [PROFILE_STATUS.EMPTY, PROFILE_STATUS.SUSPENEDED],
      icon: <AccountKeyIcon />,
      authorities: [AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DOMAIN_ADMIN],
    },
    approve: {
      title: I18n.str('approveOperator', 'Approve Operator'),
      message: '',
      icon: <AccountHeartIcon />,
      statuses: [PROFILE_STATUS.SUSPENEDED, PROFILE_STATUS.PENDING],
      authorities: [AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DOMAIN_ADMIN],
    },
    revoke: {
      title: I18n.str('revokeOperator', 'Revoke Operator'),
      message: '',
      icon: <AccountOffIcon />,
      statuses: [PROFILE_STATUS.ACTIVE, PROFILE_STATUS.PENDING],
      authorities: [AUTHORITIES.ACCOUNT_ADMIN, AUTHORITIES.DOMAIN_ADMIN],
    },
  },
};
